import * as React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import FlexContentContainer from '../../common/components/FlexContentContainer';
import { AdministrationStores } from '../stores';
import { STORE_HOME_SHORTCUTS } from '../constants';
import { Layout, Button } from 'antd';
import LayoutHeader from '../../../components/LayoutHeader';
import { PlusOutlined } from '@ant-design/icons';
import ShortcutsList from '../components/ShortcutsList';
import ShortcutEditModal from '../components/ShortcutEditModal';

type Props = AdministrationStores;

const HomeShortcutsPage: React.FC<Props> = ({ HomeShortcuts: store }) => {
    React.useEffect(() => {
        if (!store) {
            return;
        }

        store.initialize();

        return () => {
            store.dispose();
        };
    }, [store]);

    if (!store) {
        return null;
    }

    const content = (
        <HasPermission
            permissionClaim={AppPermissions.CanManageShortcuts}
            yes={() => (
                <Layout className="screen-size" style={{ height: '100%', background: '#fff' }}>
                    <LayoutHeader
                        title="Home Screen Shortcuts"
                        buttons={[
                            <Button
                                key="add-shortcut"
                                type="primary"
                                size="large"
                                icon={<PlusOutlined />}
                                disabled={!store.canAddMore || store.isSaving}
                                onClick={store.openCreateModal}
                            >
                                Add shortcut
                            </Button>
                        ]}
                    />
                    <Layout.Content style={{ padding: '0 0 16px', overflow: 'auto' }}>
                        <ShortcutsList store={store} />
                        <ShortcutEditModal store={store} />
                    </Layout.Content>
                </Layout>
            )}
        />
    );

    return <FlexContentContainer content={content} contentStyle={{ overflow: 'hidden' }} />;
};

export default inject(STORE_HOME_SHORTCUTS)(observer(HomeShortcutsPage));
